import { format, parse } from 'date-fns';
import { urlUtils } from '../utils/url';

const packageModel = {
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
  get rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get departureAirportId() {
    return urlUtils.getDepartureIdFromUrl();
  },
  get resortId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get areaId() {
    const areaId = urlUtils.getAreaIdFromUrl();
    return areaId === '-1' ? '' : areaId;
  },
  get departureDate() {
    const departureDateFromUrl = urlUtils.getDepartureDateFromUrl();
    if (!departureDateFromUrl) return null;

    const departureDate = parse(departureDateFromUrl, 'yyyyMMdd', new Date());
    return format(departureDate, 'yyyy-MM-dd');
  },
  get returnDate() {
    const returnDateFromUrl = urlUtils.getReturnDateFromUrl();
    if (!returnDateFromUrl) return null;

    const returnDate = parse(returnDateFromUrl, 'yyyyMMdd', new Date());
    return format(returnDate, 'yyyy-MM-dd');
  },
  get duration() {
    return urlUtils.getDurationFromUrl();
  },
  get transportKey() {
    return urlUtils.getTransportKeyFromUrl();
  },
  get transportId() {
    return urlUtils.getTransportIdFromUrl();
  },
  get hotelId() {
    return urlUtils.getHotelIdFromUrl();
  },
  get accomodationKey() {
    return urlUtils.getAccommodationKeyFromUrl();
  },
  get roomGroupKey() {
    return urlUtils.getRoomGroupKeyFromUrl();
  },
  get bestPrice() {
    const bestPriceString = urlUtils.getBestPriceFromUrl();
    if (bestPriceString.toLowerCase() === 'true') {
      return true;
    }
    return false;
  },
  get fastestFlight() {
    const fastestFlightString = urlUtils.getFastestFlightFromUrl();
    if (fastestFlightString.toLowerCase() === 'true') {
      return true;
    }
    return false;
  },
  get tdmRuleId() {
    return urlUtils.getTdmRuleIdFromUrl();
  },
  get selectedCabin() {
    return urlUtils.getSelectedCabinFromUrl();
  },
  get selectedHotelCode() {
    return urlUtils.getSelectedHotelCodeFromUrl();
  },
  get price() {
    return urlUtils.getPriceFromUrl();
  },
  get isStandalone() {
    return urlUtils.getIsStandaloneFromUrl();
  },
  get tripContext() {
    return urlUtils.getTripContextFromUrl();
  },
  get cabinClass() {
    return urlUtils.getCabinClassFromUrl();
  },
  get directFlight() {
    return urlUtils.getDirectFlightFromUrl();
  },
  get includeBaggage() {
    return urlUtils.getIncludeBaggageFromUrl();
  },
};

export default packageModel;
